import React from "react";
import "./SocialSection.css";
import {
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaTumblr,
} from "react-icons/fa";
import { FaXTwitter } from 'react-icons/fa6';

const socialLinks = [
    {
    icon: <FaYoutube />,
    title: "IRC-Islamic Research Centre",
    url: "https://www.youtube.com/@IRCTV",
    color: "#FF0000",

  },
   {
    icon: <FaInstagram />,
    title: "IRC-Islamic Research Centre",
    url: "https://www.instagram.com/irc.tv",
    color: "#E1306C",
  },
  {
    icon: <FaFacebookF />,
    title: "IRC-Islamic Research Centre",
    url: "https://www.facebook.com/Islamicresearchcentre",
    color: "#1877F2",
  },

  {
    icon: <FaXTwitter />,
    title: "IRC-Islamic Research Centre",
    url: "https://x.com/IRCTV",
    color: "#000000",

  },
  {
    icon: <FaLinkedinIn />,
    title: "IRC-Islamic Research Centre",
    url: "https://www.linkedin.com/company/islamic-research-centre",
    color: "#0A66C2",


  },
];

const socialLinks2 = [
    {
    icon: <FaYoutube />,
    title: "Adv. Faiz Syed",
    url: "https://www.youtube.com/@AdvFaizSyedOfficial",
    color: "#FF0000",

  },
    {
    icon: <FaInstagram />,
    title: "Adv. Faiz Syed",
    url: "https://www.instagram.com/advfaizsyed",
    color: "#E1306C",

  },
  {
    icon: <FaFacebookF />,
    title: "Adv. Faiz Syed",
    url: "https://www.facebook.com/FaizAliSyed",
    color: "#1877F2",
  },

  {
    icon: <FaXTwitter />,
    title: "Adv. Faiz Syed",
    url: "https://x.com/advfaizsyed",
    color: "#000000",

  },
  {
    icon: <FaLinkedinIn />,
    title: "Adv. Faiz Syed",
    url: "https://www.linkedin.com/in/advfaizsyed",
    color: "#0A66C2",

  },

  {
    icon: <FaTumblr />,
    title: "Adv. Faiz Syed",
    url: "https://www.linkedin.com/in/advfaizsyed",
    color: "#36465D",

  },
];

const SocialSection = () => {
  return (
    <div className="social-section">
      <div className="overlay">
        <h2 className="title">Follow Us</h2>
        <p className="subtitle">Our Social media presence</p>



        <h2 className="title">Adv. Faiz Syed</h2>
        <div className="social-grid">
          {socialLinks2.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="social-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon" style={{ color: link.color, borderColor: link.color }}>{link.icon}</div>
              <div>
                <p className="social-title">{link.title}</p>
                {/* <p className="social-name">{link.name}</p> */}
              </div>
            </a>
          ))}
        </div>

        <h2 className="title">IRC</h2>
        <div className="social-grid">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="social-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon" style={{ color: link.color, borderColor: link.color }}>{link.icon}</div>
              <div>
                <p className="social-title">{link.title}</p>
                <p className="social-name">{link.name}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="join-us">
          <h2 className="title">Connect With Us</h2>
          <p>
            Be part of a growing community committed to knowledge, positivity, and purpose.
            Stay updated with our latest events, videos, and announcements.
          </p>
          <div className="join-buttons">
            <a
              href="http://whatsapp.com/channel/0029Va5YrBS8qIzzLL8eyF2Y"
              className="whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              👉 Join Our <strong>WhatsApp Channel</strong>
            </a>
            <a
              href="https://t.me/AdvFaizSyed"
              className="telegram"
              target="_blank"
              rel="noopener noreferrer"
            >
              📢 Follow Us on <strong>Telegram</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialSection;
